import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { PhotoGalleryModal } from '../components/PhotoGalleryModal';
import { MapPin, ShieldCheck, Zap, Filter, Map as MapIcon, Camera, Star, Wifi, Droplets, Lock, Grid3x3, List, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';
const hostels = [{
  id: 1,
  name: 'Emerald Heights',
  location: 'Unilag, Akoka',
  price: '₦450,000',
  period: '/session',
  verified: true,
  rating: 4.8,
  reviews: 24,
  amenities: ['24/7 Power', 'Security', 'Water', 'WiFi'],
  type: 'Self-contain',
  featured: true,
  images: ['https://images.unsplash.com/photo-1555854877-bab0e564b8d5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1556911220-e15b29be8c8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Bedroom', 'Kitchen', 'Bathroom', 'Exterior']
}, {
  id: 2,
  name: 'Sunshine Lodge',
  location: 'Yaba Tech, Yaba',
  price: '₦250,000',
  period: '/session',
  verified: true,
  rating: 4.5,
  reviews: 18,
  amenities: ['Water', 'Security', 'WiFi'],
  type: 'Single Room',
  featured: false,
  images: ['https://images.unsplash.com/photo-1596276020587-8044fe049813?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1512918760532-3ed00af63671?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Room View', 'Bedroom', 'Common Area']
}, {
  id: 3,
  name: 'The Haven',
  location: 'Unilag, Bariga',
  price: '₦600,000',
  period: '/session',
  verified: true,
  rating: 4.9,
  reviews: 31,
  amenities: ['AC', '24/7 Power', 'Gym', 'WiFi'],
  type: 'Flat',
  featured: true,
  images: ['https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Living Area', 'Bedroom', 'Kitchen']
}, {
  id: 4,
  name: 'Student Village',
  location: 'LUTH, Idi-Araba',
  price: '₦350,000',
  period: '/session',
  verified: true,
  rating: 4.3,
  reviews: 15,
  amenities: ['Security', 'Common Room', 'Water'],
  type: 'Shared',
  featured: false,
  images: ['https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1555854877-bab0e564b8d5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Shared Room', 'Study Area', 'Bathroom']
}, {
  id: 5,
  name: 'Royal Residence',
  location: 'FUTA, Akure',
  price: '₦380,000',
  period: '/session',
  verified: true,
  rating: 4.7,
  reviews: 22,
  amenities: ['24/7 Power', 'Security', 'Water', 'Parking'],
  type: 'Self-contain',
  featured: true,
  images: ['https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1556911220-e15b29be8c8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Bedroom', 'Living Room', 'Kitchen']
}, {
  id: 6,
  name: 'Campus View Apartments',
  location: 'Covenant University',
  price: '₦520,000',
  period: '/session',
  verified: true,
  rating: 4.6,
  reviews: 19,
  amenities: ['AC', 'WiFi', 'Security', '24/7 Power'],
  type: 'Self-contain',
  featured: false,
  images: ['https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Bedroom', 'Study Area', 'Bathroom']
}, {
  id: 7,
  name: 'Green Park Lodge',
  location: 'UI, Ibadan',
  price: '₦320,000',
  period: '/session',
  verified: true,
  rating: 4.4,
  reviews: 16,
  amenities: ['Water', 'Security', 'Parking', 'WiFi'],
  type: 'Single Room',
  featured: false,
  images: ['https://images.unsplash.com/photo-1555854877-bab0e564b8d5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1596276020587-8044fe049813?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1512918760532-3ed00af63671?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Room', 'Entrance', 'Common Area']
}, {
  id: 8,
  name: 'Elite Suites',
  location: 'Babcock University',
  price: '₦480,000',
  period: '/session',
  verified: true,
  rating: 4.8,
  reviews: 27,
  amenities: ['AC', '24/7 Power', 'WiFi', 'Gym', 'Pool'],
  type: 'Flat',
  featured: false,
  images: ['https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Living Room', 'Bedroom', 'Kitchen']
}, {
  id: 9,
  name: 'Scholars Den',
  location: 'LASU, Ojo',
  price: '₦280,000',
  period: '/session',
  verified: true,
  rating: 4.2,
  reviews: 12,
  amenities: ['Water', 'Security', 'Study Room'],
  type: 'Shared',
  featured: false,
  images: ['https://images.unsplash.com/photo-1596276020587-8044fe049813?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1555854877-bab0e564b8d5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'],
  captions: ['Shared Room', 'Bedroom', 'Bathroom']
}];
export function FindHostelPage() {
  const [showMap, setShowMap] = useState(false);
  const [galleryOpen, setGalleryOpen] = useState(false);
  const [selectedHostel, setSelectedHostel] = useState<(typeof hostels)[0] | null>(null);
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [sortBy, setSortBy] = useState('featured');
  const navigate = useNavigate();
  const openGallery = (e: React.MouseEvent, hostel: (typeof hostels)[0]) => {
    e.stopPropagation();
    setSelectedHostel(hostel);
    setGalleryOpen(true);
  };
  let sortedHostels = [...hostels];
  if (sortBy === 'price-low') {
    sortedHostels.sort((a, b) => parseInt(a.price.replace(/[₦,]/g, '')) - parseInt(b.price.replace(/[₦,]/g, '')));
  } else if (sortBy === 'price-high') {
    sortedHostels.sort((a, b) => parseInt(b.price.replace(/[₦,]/g, '')) - parseInt(a.price.replace(/[₦,]/g, '')));
  } else if (sortBy === 'rating') {
    sortedHostels.sort((a, b) => b.rating - a.rating);
  }
  const featuredHostels = sortedHostels.filter(h => h.featured);
  const regularHostels = sortedHostels.filter(h => !h.featured);
  return <div className="min-h-screen bg-slate-50 pt-20" data-id="element-499">
      <Navigation data-id="element-500" />

      {selectedHostel && <PhotoGalleryModal isOpen={galleryOpen} onClose={() => setGalleryOpen(false)} images={selectedHostel.images} captions={selectedHostel.captions} data-id="element-501" />}

      {/* Search Header */}
      <div className="bg-white border-b border-slate-200 sticky top-20 z-20 shadow-sm" data-id="element-502">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-503">
          <div className="flex flex-col md:flex-row gap-4 items-center justify-between" data-id="element-504">
            <div className="flex items-center gap-2 w-full md:w-auto" data-id="element-505">
              <div className="relative flex-1 md:w-80" data-id="element-506">
                <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5" data-id="element-507" />
                <input type="text" placeholder="Search by campus or area..." className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:outline-none" data-id="element-508" />
              </div>
              <Button variant="outline" className="md:hidden" data-id="element-509">
                <Filter className="w-5 h-5" data-id="element-510" />
              </Button>
            </div>

            <div className="flex items-center gap-3 w-full md:w-auto overflow-x-auto pb-2 md:pb-0" data-id="element-511">
              <select value={sortBy} onChange={e => setSortBy(e.target.value)} className="h-9 rounded-md border border-slate-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-primary whitespace-nowrap" data-id="element-512">
                <option value="featured" data-id="element-513">Featured First</option>
                <option value="price-low" data-id="element-514">Price: Low to High</option>
                <option value="price-high" data-id="element-515">Price: High to Low</option>
                <option value="rating" data-id="element-516">Highest Rated</option>
              </select>
              <div className="h-6 w-px bg-slate-300 mx-2 hidden md:block" data-id="element-517"></div>
              <div className="flex border border-slate-300 rounded-md overflow-hidden" data-id="element-518">
                <button onClick={() => setViewMode('grid')} className={`p-2 ${viewMode === 'grid' ? 'bg-brand-primary text-white' : 'bg-white text-slate-600'}`} data-id="element-519">
                  <Grid3x3 className="w-4 h-4" data-id="element-520" />
                </button>
                <button onClick={() => setViewMode('list')} className={`p-2 ${viewMode === 'list' ? 'bg-brand-primary text-white' : 'bg-white text-slate-600'}`} data-id="element-521">
                  <List className="w-4 h-4" data-id="element-522" />
                </button>
              </div>
              <Button variant={showMap ? 'primary' : 'outline'} size="sm" onClick={() => setShowMap(!showMap)} className="whitespace-nowrap" data-id="element-523">
                <MapIcon className="w-4 h-4 mr-2" data-id="element-524" />
                {showMap ? 'Show List' : 'Show Map'}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Section className="!py-8" data-id="element-525">
        <div className="flex gap-8" data-id="element-526">
          {/* Filters Sidebar - Desktop */}
          <div className="hidden lg:block w-64 flex-shrink-0 space-y-6" data-id="element-527">
            <div data-id="element-528">
              <h3 className="font-semibold text-brand-dark mb-3" data-id="element-529">Campus</h3>
              <div className="space-y-2" data-id="element-530">
                {['FUTA', 'Unilag', 'Yaba Tech', 'LUTH', 'Covenant', 'Babcock', 'UI', 'LASU'].map(campus => <label key={campus} className="flex items-center gap-2 text-sm text-slate-600" data-id="element-531">
                    <input type="checkbox" className="rounded border-slate-300 text-brand-primary focus:ring-brand-primary" data-id="element-532" />
                    {campus}
                  </label>)}
              </div>
            </div>

            <div data-id="element-533">
              <h3 className="font-semibold text-brand-dark mb-3" data-id="element-534">Room Type</h3>
              <div className="space-y-2" data-id="element-535">
                {['Self-contain', 'Single Room', 'Shared', 'Flat'].map(type => <label key={type} className="flex items-center gap-2 text-sm text-slate-600" data-id="element-536">
                      <input type="checkbox" className="rounded border-slate-300 text-brand-primary focus:ring-brand-primary" data-id="element-537" />
                      {type}
                    </label>)}
              </div>
            </div>

            <div data-id="element-538">
              <h3 className="font-semibold text-brand-dark mb-3" data-id="element-539">Amenities</h3>
              <div className="space-y-2" data-id="element-540">
                {['24/7 Power', 'Water', 'Security', 'AC', 'Kitchen', 'WiFi', 'Gym'].map(item => <label key={item} className="flex items-center gap-2 text-sm text-slate-600" data-id="element-541">
                    <input type="checkbox" className="rounded border-slate-300 text-brand-primary focus:ring-brand-primary" data-id="element-542" />
                    {item}
                  </label>)}
              </div>
            </div>
          </div>

          {/* Grid */}
          <div className="flex-1" data-id="element-543">
            <h2 className="text-xl font-bold text-brand-dark mb-6" data-id="element-544">
              {hostels.length} Verified Hostels Found
            </h2>

            {/* Featured Hostels */}
            {featuredHostels.length > 0 && <div className="mb-8" data-id="element-545">
                <div className="flex items-center gap-2 mb-4" data-id="element-546">
                  <TrendingUp className="w-5 h-5 text-brand-primary" data-id="element-547" />
                  <h3 className="text-lg font-bold text-brand-dark" data-id="element-548">
                    Featured Hostels
                  </h3>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-549">
                  {featuredHostels.map((hostel, index) => <motion.div key={hostel.id} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: index * 0.1
              }} data-id="element-550">
                      <Card className="overflow-hidden hover:shadow-md transition-shadow group cursor-pointer h-full flex flex-col border-brand-primary/30" onClick={() => navigate(`/hostel/${hostel.id}`)} data-id="element-551">
                        <div className="relative h-48 overflow-hidden" data-id="element-552">
                          <img src={hostel.images[0]} alt={hostel.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-553" />
                          {hostel.verified && <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full flex items-center gap-1 text-xs font-bold text-emerald-700 shadow-sm z-10" data-id="element-554">
                              <ShieldCheck className="w-3 h-3" data-id="element-555" />
                              VERIFIED
                            </div>}
                          <div className="absolute top-3 left-3 px-2 py-1 bg-brand-primary text-white text-xs font-bold rounded-full z-10" data-id="element-556">
                            FEATURED
                          </div>
                          <div className="absolute bottom-3 left-3 bg-brand-dark/80 backdrop-blur-sm px-2 py-1 rounded text-xs font-medium text-white z-10" data-id="element-557">
                            {hostel.type}
                          </div>

                          <button onClick={e => openGallery(e, hostel)} className="absolute bottom-3 right-3 bg-black/50 hover:bg-black/70 text-white p-1.5 rounded-full backdrop-blur-sm transition-colors z-10" data-id="element-558">
                            <Camera className="w-4 h-4" data-id="element-559" />
                          </button>
                        </div>

                        <div className="p-4 flex-1 flex flex-col" data-id="element-560">
                          <div className="flex justify-between items-start mb-2" data-id="element-561">
                            <div data-id="element-562">
                              <h3 className="font-bold text-brand-dark text-lg" data-id="element-563">
                                {hostel.name}
                              </h3>
                              <p className="text-slate-500 text-sm flex items-center gap-1" data-id="element-564">
                                <MapPin className="w-3 h-3" data-id="element-565" /> {hostel.location}
                              </p>
                            </div>
                          </div>

                          <div className="flex items-center gap-1 mb-3" data-id="element-566">
                            <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-567" />
                            <span className="font-bold text-sm" data-id="element-568">
                              {hostel.rating}
                            </span>
                            <span className="text-xs text-slate-500" data-id="element-569">
                              ({hostel.reviews} reviews)
                            </span>
                          </div>

                          <div className="flex flex-wrap gap-2 mb-4" data-id="element-570">
                            {hostel.amenities.slice(0, 3).map(amenity => <span key={amenity} className="text-xs bg-slate-100 text-slate-600 px-2 py-1 rounded-full flex items-center gap-1" data-id="element-571">
                                {amenity === '24/7 Power' ? <Zap className="w-3 h-3" data-id="element-572" /> : amenity === 'Water' ? <Droplets className="w-3 h-3" data-id="element-573" /> : amenity === 'Security' ? <Lock className="w-3 h-3" data-id="element-574" /> : amenity === 'WiFi' ? <Wifi className="w-3 h-3" data-id="element-575" /> : null}
                                {amenity}
                              </span>)}
                          </div>

                          <div className="mt-auto pt-4 border-t border-slate-100 flex items-center justify-between" data-id="element-576">
                            <div data-id="element-577">
                              <span className="text-lg font-bold text-brand-primary" data-id="element-578">
                                {hostel.price}
                              </span>
                              <span className="text-xs text-slate-400" data-id="element-579">
                                {hostel.period}
                              </span>
                            </div>
                            <Button size="sm" data-id="element-580">View Details</Button>
                          </div>
                        </div>
                      </Card>
                    </motion.div>)}
                </div>
              </div>}

            {/* Regular Hostels */}
            <div className={viewMode === 'grid' ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6' : 'space-y-4'} data-id="element-581">
              {regularHostels.map((hostel, index) => <motion.div key={hostel.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.05
            }} data-id="element-582">
                  <Card className={`overflow-hidden hover:shadow-md transition-shadow group cursor-pointer ${viewMode === 'list' ? 'flex flex-row' : 'h-full flex flex-col'}`} onClick={() => navigate(`/hostel/${hostel.id}`)} data-id="element-583">
                    <div className={`relative overflow-hidden ${viewMode === 'list' ? 'w-48 h-48' : 'h-48'}`} data-id="element-584">
                      <img src={hostel.images[0]} alt={hostel.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-585" />
                      {hostel.verified && <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full flex items-center gap-1 text-xs font-bold text-emerald-700 shadow-sm z-10" data-id="element-586">
                          <ShieldCheck className="w-3 h-3" data-id="element-587" />
                          VERIFIED
                        </div>}
                      <div className="absolute bottom-3 left-3 bg-brand-dark/80 backdrop-blur-sm px-2 py-1 rounded text-xs font-medium text-white z-10" data-id="element-588">
                        {hostel.type}
                      </div>

                      <button onClick={e => openGallery(e, hostel)} className="absolute bottom-3 right-3 bg-black/50 hover:bg-black/70 text-white p-1.5 rounded-full backdrop-blur-sm transition-colors z-10" data-id="element-589">
                        <Camera className="w-4 h-4" data-id="element-590" />
                      </button>
                    </div>

                    <div className="p-4 flex-1 flex flex-col" data-id="element-591">
                      <div className="flex justify-between items-start mb-2" data-id="element-592">
                        <div data-id="element-593">
                          <h3 className="font-bold text-brand-dark text-lg" data-id="element-594">
                            {hostel.name}
                          </h3>
                          <p className="text-slate-500 text-sm flex items-center gap-1" data-id="element-595">
                            <MapPin className="w-3 h-3" data-id="element-596" /> {hostel.location}
                          </p>
                        </div>
                      </div>

                      <div className="flex items-center gap-1 mb-3" data-id="element-597">
                        <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-598" />
                        <span className="font-bold text-sm" data-id="element-599">
                          {hostel.rating}
                        </span>
                        <span className="text-xs text-slate-500" data-id="element-600">
                          ({hostel.reviews} reviews)
                        </span>
                      </div>

                      <div className="flex flex-wrap gap-2 mb-4" data-id="element-601">
                        {hostel.amenities.slice(0, 3).map(amenity => <span key={amenity} className="text-xs bg-slate-100 text-slate-600 px-2 py-1 rounded-full flex items-center gap-1" data-id="element-602">
                            {amenity === '24/7 Power' ? <Zap className="w-3 h-3" data-id="element-603" /> : amenity === 'Water' ? <Droplets className="w-3 h-3" data-id="element-604" /> : amenity === 'Security' ? <Lock className="w-3 h-3" data-id="element-605" /> : amenity === 'WiFi' ? <Wifi className="w-3 h-3" data-id="element-606" /> : null}
                            {amenity}
                          </span>)}
                      </div>

                      <div className="mt-auto pt-4 border-t border-slate-100 flex items-center justify-between" data-id="element-607">
                        <div data-id="element-608">
                          <span className="text-lg font-bold text-brand-primary" data-id="element-609">
                            {hostel.price}
                          </span>
                          <span className="text-xs text-slate-400" data-id="element-610">
                            {hostel.period}
                          </span>
                        </div>
                        <Button size="sm" data-id="element-611">View Details</Button>
                      </div>
                    </div>
                  </Card>
                </motion.div>)}
            </div>
          </div>
        </div>
      </Section>
    </div>;
}